// extracted by mini-css-extract-plugin
export var dateLabel = "_48-0";
export var dateLabelError = "_48-1";
export var fullWidth = "_48-2";
export var smaller = "_48-3";